import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { AssignedOperator } from 'src/pages/shipper-admin/details/types';
import { ShipperUserDataRequest } from 'src/pages/shipper-admin/details/use-shipper-user-data';

export function useAssignedOperators(shipperUserData: ShipperUserDataRequest) {
  const assignedOperators = useAxios(
    (axios, signal, shipperUserRefId: number) =>
      axios.request<AssignedOperator[]>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/${shipperUserRefId}/assigned-operators?detailLevel=PUBLIC`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!shipperUserData.response) return;

    assignedOperators.execute(shipperUserData.response.data.shipperUserRefId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipperUserData.response]);

  return assignedOperators;
}

export type AssignedOperatorsRequest = ReturnType<typeof useAssignedOperators>;
